import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useCompanyInformationForm } from '../../contexts/companyInformationFormContext'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { closeModal, isLoading, isProcessing, submitForm } = useCompanyInformationForm()

  const handleCloseButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleSaveButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <ButtonsGroup>
      <Button disabled={isProcessing} variant="text" onClick={handleCloseButtonClick}>
        {t('cancel')}
      </Button>
      <Button disabled={isProcessing} loading={isLoading} onClick={handleSaveButtonClick}>
        {t('save')}
      </Button>
    </ButtonsGroup>
  )
}
